import { useMutation } from "react-query";

import { $ok } from "foundation-ts/commons";

import { useAuthContext } from '@hooks/useAuthContext';
import { checkAdminOTP } from "@services/authentication.service";
import { getAdminProfile } from "@services/users.service";
import { optlog } from "@utils/functions";

export const useCheckOTP = () => {
    const { pendingAdminId, setAdminUser } = useAuthContext();

    return useMutation(
        async ({ otp }: {otp: string}) => {
            if (!$ok(pendingAdminId)) { throw new Error('No waiting admin authentication'); }
            const isValid = await checkAdminOTP(pendingAdminId, otp);
            return { checked: isValid, uid: pendingAdminId! };
        },
        {
            onSuccess: async (data) => {
                if (!data.checked) { return; }
                try {
                    optlog('Valid OTP, loading admin profile');
                    const adminUser = await getAdminProfile(data.uid);
                    setAdminUser(adminUser);
                } catch (e) {
                    optlog('Error loading admin profile:', e);
                    throw new Error('Error loading admin profile');
                }
            },
            onError: (error) => {
                optlog('Error when checking OTP:', error);
                throw error;
            },
        }
    );
}

